import RejectPaymentPlanError from './RejectPaymentPlanError';
class PaymentPlanIsNotRegistered extends RejectPaymentPlanError {
    paymentPlanId;
    constructor(paymentPlanId, options) {
        super('Payment plan is not registered', options);
        this.paymentPlanId = paymentPlanId;
    }
}
export default PaymentPlanIsNotRegistered;
